// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";

import Button from "../../_atoms/Button";

export const ResultsList = styled.ul`
  width: 100%;
`;

export const SeeAllRunnersSection = styled.div`
  width: 100%;
  padding: 0 12px 12px;
  background-color: ${buildColor("white", "100")};
`;

export const AllRunnersButton = styled(Button)`
  width: 100%;
`;

export const IconContainer = styled.div`
  padding-left: 3px;
  height: 16px;
`;

export const OtherInfo = styled.div`
  display: flex;
  flex-direction: column;
  background: ${buildColor("white", "100")};
  font-size: 12px;
  padding: 12px 8px;

  & > :nth-child(2) {
    margin-top: 8px;
  }
`;

export const ScratchesLabel = styled.strong`
  padding-right: 10px;
  color: ${buildColor("grey", "900")};
  font-size: 14px;
  font-family: ${fontNormal};
  font-weight: 400;
`;

export const Scratches = styled.div`
  display: flex;
  align-items: center;
  margin-left: 60px;
  color: ${buildColor("grey", "800")};
`;

export const Number = styled.div`
  width: 20px;
  text-align: center;
  margin-right: 4px;
`;

export const RunnerResultsContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${buildColor("grey", "000")};
    `};

  & > div:last-child {
    flex: 1;
  }
`;

export const FinishPosition = styled.span`
  width: 32px;
  text-align: left;
  font-size: 12px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "900")};
  margin-top: 12px;
  margin-left: 16px;
`;
